import React from 'react';

let enabled = false;

export default class ScrollTop extends React.Component {
  componentDidMount() {
    if (enabled) {
      window.scrollTo(0, 0);
    } else {
      enabled = true;
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ../src/client/components/scroll/ScrollTop.js